module.exports = __webpack_public_path__ + "img/8bea326.jpg";